import { useProfile } from "../../authentication/state/profile";

import AccountAgreementsView from "../views/AccountAgreementsView/AccountAgreementsView";

export default function AccountAgreements() {
	const profile = useProfile();

	return <AccountAgreementsView user={profile} />;
}
